import { Plus, TrendingDown, PieChart } from 'lucide-react'

export default function Finances() {
  return (
    <div className="p-4 md:p-6 max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Фінанси</h1>
          <p className="text-slate-400 text-sm mt-0.5">Контроль витрат і бюджету</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <Plus size={18} />
          Додати витрату
        </button>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="card p-5">
          <div className="text-sm text-slate-400 mb-1">Витрати цього місяця</div>
          <div className="text-3xl font-semibold">₴ 24 500</div>
          <div className="text-sm text-slate-500 mt-1">з бюджету ₴ 40 000</div>
          <div className="mt-4 h-2 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full bg-violet-500 rounded-full" style={{ width: '61%' }} />
          </div>
        </div>
        <div className="card p-5">
          <div className="text-sm text-slate-400 mb-1">Сьогодні</div>
          <div className="text-3xl font-semibold">₴ 680</div>
          <div className="flex items-center gap-1 text-sm text-emerald-400 mt-1">
            <TrendingDown size={14} />
            -12% від середнього
          </div>
        </div>
      </div>

      <div className="card p-5">
        <div className="flex items-center gap-2 mb-4">
          <PieChart size={18} className="text-violet-400" />
          <h2 className="font-medium">Категорії</h2>
        </div>
        <div className="space-y-3">
          {[
            { name: 'Їжа', amount: 9500, pct: 38, color: 'bg-violet-500' },
            { name: 'Транспорт', amount: 5200, pct: 21, color: 'bg-blue-500' },
            { name: 'Розваги', amount: 4100, pct: 17, color: 'bg-emerald-500' },
            { name: 'Комунальні', amount: 3400, pct: 14, color: 'bg-amber-500' },
            { name: 'Інше', amount: 2300, pct: 10, color: 'bg-slate-500' },
          ].map((cat) => (
            <div key={cat.name} className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${cat.color}`} />
              <span className="text-sm flex-1">{cat.name}</span>
              <span className="text-sm text-slate-400">₴ {cat.amount.toLocaleString('uk-UA')}</span>
              <span className="text-xs text-slate-500 w-10 text-right">{cat.pct}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
